<div class="cm-embed">
  <div class="v2-toolbar">
    <mat-spinner *ngIf="loading" diameter="24" class="v2-inline-spin"></mat-spinner>
    <button mat-stroked-button (click)="load()" [disabled]="loading">
      <mat-icon>refresh</mat-icon> Reload from Vendon
    </button>
  </div>

  <p class="v2-note">
    Coffee machines from Vendon with their cups for <strong>{{ month }}</strong>. Cups are read automatically; set here
    who each machine bills, the price per cup and which cups count. <em>Free</em> = free to the employee, so the
    company pays per cup. <em>Card</em> = the employee paid at the machine. Service (test) cups are never billed.
    The system is where the coffee counts toward garantiomsetning, also for machines that are not billed.
    Changes apply the next time invoices are built.
  </p>

  <div class="v2-empty v2-error" *ngIf="loadError"><mat-icon>error_outline</mat-icon> {{ loadError }}</div>
  <div class="v2-empty v2-error" *ngIf="vendonErrors.length">
    <mat-icon>error_outline</mat-icon> Vendon could not count: {{ vendonErrors.join('; ') }}
  </div>
  <div class="v2-empty v2-error" *ngIf="unsetCount">
    <mat-icon>new_releases</mat-icon>
    {{ unsetCount }} machine(s) are not set up yet. One with cups this month stops invoicing until it is saved —
    either billed to a customer or switched to "not billed".
  </div>

  <div class="v2-table-wrap" *ngIf="rows.length">
    <table class="v2-plain-table cm-table">
      <thead>
        <tr>
          <th>Machine</th>
          <th class="num" matTooltip="Free to the employee">Free</th>
          <th class="num" matTooltip="Paid by card at the machine">Card</th>
          <th class="num" matTooltip="Service vends, never billed">Test</th>
          <th>Billed by Frigg</th>
          <th>Paid by</th>
          <th>System</th>
          <th class="num">Price / cup</th>
          <th>Bill cups</th>
          <th class="num">Amount (ex-VAT)</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows; trackBy: trackRow" [class.cm-unset]="!r.configured" [class.cm-off]="r.configured && !r.billable">
          <td>
            {{ r.name }} <span class="cm-id">#{{ r.vendonMachineId }}</span>
            <span class="v2-chip v2-chip-warn" *ngIf="!r.configured">new</span>
          </td>
          <td class="num">{{ r.counts ? cups(r, 'FREEVEND') : '?' }}</td>
          <td class="num">{{ r.counts ? cups(r, 'CASHLESS') : '?' }}</td>
          <td class="num cm-muted">{{ r.counts ? cups(r, 'TEST') : '?' }}</td>
          <td>
            <mat-slide-toggle [ngModel]="r.billable" (ngModelChange)="setBillable(r, $event)"></mat-slide-toggle>
            <input *ngIf="!r.billable" type="text" class="go-input cm-reason" placeholder="Why not (optional)"
                   [(ngModel)]="r.reason" (ngModelChange)="touch(r)">
          </td>
          <td>
            <mat-select class="go-select cm-select" [(ngModel)]="r.kundekortId" (selectionChange)="touch(r)"
                        placeholder="Choose customer" [disabled]="!r.billable">
              <mat-option [value]="null">—</mat-option>
              <mat-option *ngFor="let c of customers" [value]="c.id">{{ c.name }}</mat-option>
            </mat-select>
          </td>
          <td>
            <mat-select class="go-select cm-select" [(ngModel)]="r.systemId" (selectionChange)="touch(r)" placeholder="—">
              <mat-option [value]="null">—</mat-option>
              <mat-option *ngFor="let s of systems" [value]="s.id">{{ s.name }}</mat-option>
            </mat-select>
          </td>
          <td class="num">
            <input type="number" class="go-input go-input-sm" min="0" step="0.5" [disabled]="!r.billable"
                   [(ngModel)]="r.pricePerCupExVat" (ngModelChange)="touch(r)">
          </td>
          <td class="cm-types">
            <mat-checkbox *ngFor="let t of paymentTypes" [checked]="r.paymentTypes.includes(t.key)" [disabled]="!r.billable"
                          (change)="toggleType(r, t.key)" [matTooltip]="t.hint">{{ t.label }}</mat-checkbox>
          </td>
          <td class="num"><strong *ngIf="r.billable">{{ amount(r) | number:'1.2-2' }}</strong><span *ngIf="!r.billable" class="cm-muted">—</span></td>
          <td class="cm-actions">
            <button mat-flat-button color="primary" *ngIf="r.dirty || !r.configured" (click)="save(r)" [disabled]="r.saving">
              {{ r.saving ? 'Saving…' : 'Save' }}
            </button>
            <div class="cm-error" *ngIf="r.error">{{ r.error }}</div>
          </td>
        </tr>
        <tr class="v2-invoice-total">
          <td colspan="9">Coffee billed for {{ month }}</td>
          <td class="num"><strong>{{ total | number:'1.2-2' }}</strong></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
